<ng-container *ngIf="initialized">

  <mvs-widget
    *ngIf="personsWidget"
    [widgetData]="personsWidget"
    [importObjectContext]="contextContractAndCustomer"
    [widgetToolbarButtons]="personWidgetToolbarButtons"
    (onToolbarButtonClick)="handlePersonWidgetToolbarClick($event)"
    [disableUpdate]="disableUpdate"
  ></mvs-widget>

  <mvs-widget *ngIf="objectsWidget"
              [widgetData]="objectsWidget"
              [disableUpdate]="disableUpdate"
              [importObjectContext]="contextContractAndCustomer">

  </mvs-widget>
